import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import messages from '../../messages';
import style from '../../../../components/grid-header/reusable-grid-button.module.less';
import { openProductDetailModal } from '../../../../store/products/products.actions';

const NewProductButton = () => {
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    dispatch(openProductDetailModal());
  }, [dispatch]);
  return (
    <Button className={style['reusable-button']} onClick={onClick} theme='tertiary'>
      <FormattedMessage {...messages.newProductButton} />
    </Button>
  );
};

export default NewProductButton;
